import { Dictionary } from 'lib/types'
import { languages } from 'lib/locale'
import { useLocaleAtom } from 'lib/atoms'

export const useTranslations = () => {
    const [locale] = useLocaleAtom()

    return languages[locale] as Dictionary
}
